import type { Messages } from './messages.fr';

/**
 * FORME des catalogues et résolution d'une clé — SANS aucun catalogue en dépendance.
 *
 * ⚠ L'import de `Messages` est un import de TYPE, effacé à la compilation : ce module ne
 * tire donc AUCUN des trois catalogues dans le bundle. C'est la condition du chargement à la
 * demande (cf. `catalog-loader.ts`) — y réintroduire un `import { fr } from './messages.fr'`
 * ramènerait les 13,24 kio gzippés qu'on vient d'en sortir.
 *
 * Le registre statique des trois langues n'existe plus qu'en TEST (`test-setup.ts` et les
 * tests de parité, qui doivent justement tout comparer).
 */

/**
 * Chemins de clés valides, sous forme pointée (`'nav.home'`, `'theme.light'`…).
 * Dérivés du type `Messages` → toute clé inconnue est une erreur de compilation,
 * donc « zéro texte en dur » ET « pas de clé fantôme ».
 */
type Leaves<T> = {
  [K in keyof T & string]: T[K] extends string ? K : `${K}.${Leaves<T[K]>}`;
}[keyof T & string];

export type MessageKey = Leaves<Messages>;

/** Résout un chemin pointé dans un catalogue. Renvoie la clé brute si absente (dev-safe). */
export function resolve(messages: Messages, key: MessageKey): string {
  const value = key
    .split('.')
    .reduce<unknown>((acc, part) => (acc as Record<string, unknown>)?.[part], messages);
  return typeof value === 'string' ? value : key;
}
